import { render } from "./GuideLines.vue?vue&type=template&id=84bff776&scoped=true&ts=true"
import script from "./GuideLines.vue?vue&type=script&lang=ts"
export * from "./GuideLines.vue?vue&type=script&lang=ts"

import "./GuideLines.vue?vue&type=style&index=0&id=84bff776&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84bff776"]])

export default __exports__